// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"838":"de30ff1a8385c13f","872":"8342d8e4f6456a49","920":"520d7ba0b520d214","944":"7d29ec7f76fe7535"}[chunkId] + ".js";
};